import { render, staticRenderFns } from "./ProgramadorXDiaXHora.vue?vue&type=template&id=941980a4&"
import script from "./ProgramadorXDiaXHora.vue?vue&type=script&lang=js&"
export * from "./ProgramadorXDiaXHora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports